import axios from '../../axios';
// 其他出库单列表
export const getStkOutOtherPage = data => {
  return axios({
    url: '/api/sys/stk/getStkOutOtherPage',
    method: 'post',
    data
  })
};
// 其他出库单总合计
export const getStkOutOtherSum = data => {
  return axios({
    url: '/api/sys/stk/getStkOutOtherSum',
    method: 'post',
    data
  })
};
// 其他出库单列表保存
export const saveStkOutOther = data => {
  return axios({
    url: '/api/sys/stk/saveStkOutOther',
    method: 'post',
    data
  })
};
// 其他出库单列表修改
export const updateStkOutOther = data => {
  return axios({
    url: '/api/sys/stk/updateStkOutOther',
    method: 'post',
    data
  })
};
// 其他出库单列表删除
export const deleteStkOutOthers = data => {
  return axios({
    url: '/api/sys/stk/deleteStkOutOthers',
    method: 'post',
    data
  })
};
// 其他出库单列表审核反审
export const auditStkOutOthers = data => {
  return axios({
    url: '/api/sys/stk/auditStkOutOthers',
    method: 'post',
    data
  })
};
// 其他出库单列表作废
export const cancelStkOutOthers = data => {
  return axios({
    url: '/api/sys/stk/cancelStkOutOthers',
    method: 'post',
    data
  })
};
// 其他出库单明细列表
export const getStkOutOtherEntryPage = data => {
  return axios({
    url: '/api/sys/stk/getStkOutOtherEntryPage',
    method: 'post',
    data
  })
};
// 其他出库单明细列表删除
export const deleteStkOutOtherEntrys = data => {
  return axios({
    url: '/api/sys/stk/deleteStkOutOtherEntrys',
    method: 'post',
    data
  })
};


// WEBPACK FOOTER //
// ./src/api/moudules/stk/OtherReturu.js